import { ILibraryDocument } from '@/pages/Library/libraryDocuments.types.ts'
import { memo } from 'react'
import AttachmentFile from '@/shared/Files/Attachment/AttachmentFile'
import css from './libraryDocumentTile.module.css'
import DropdownUnderThreeDots from '@/shared/Dropdowns/DropdownUnderThreeDots'
import useDropdownUnderIconCtrl from '@/shared/Dropdowns/hooks/useDropdownUnderIconCtrl.ts'
import DropdownListItemDelete from '@/shared/Dropdowns/DropdownListItem/DropdownListItemDelete'

interface IProps {
  document: Omit<ILibraryDocument, 'groupId'>
  documentUrl: string

  index: number

  onClick: (index: number) => void
  onDelete: () => void
}

const LibraryDocumentTile = (props: IProps) => {
  const threeDotsMenuCtrl = useDropdownUnderIconCtrl()

  return (
    <div
      data-active={threeDotsMenuCtrl.open}
      className={css.wrapper}
      onContextMenu={(ev) => {
        ev.preventDefault()
        ev.stopPropagation()

        threeDotsMenuCtrl.toggle()
      }}
    >
      <div className={css.threeDotsWrapper}>
        <DropdownUnderThreeDots
          position="left"
          open={threeDotsMenuCtrl.open}
          setOpen={threeDotsMenuCtrl.setOpen}
          ref={threeDotsMenuCtrl.ref}
        >
          <DropdownListItemDelete text="Удалить" onClick={props.onDelete} />
        </DropdownUnderThreeDots>
      </div>
      <AttachmentFile
        previewStyle={{ height: '150px' }}
        onClick={() => props.onClick(props.index)}
        key={props.document.id}
        name={props.document.fileName}
        url={props.documentUrl}
        extension={props.document.dataType}
        metadata={{ created: props.document.createdAt, size: props.document.size }}
      />
    </div>
  )
}

export default memo(LibraryDocumentTile)
